import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface DetalleCriterioPayload {
  id_criterio: number;
  cumple: boolean;
  calificacion?: number | null;
  observacion?: string | null;
}

export interface PlanRefuerzoPayload {
  accion: string;
  responsable?: string | null;
  fecha_compromiso: string;
}

export interface EvaluacionComportamientoPayload {
  cedula_colaborador: string;
  periodo: number;
  fecha_evaluacion: string;
  evaluador?: string | null;
  observaciones_generales?: string | null;
  detalle: DetalleCriterioPayload[];
  plan_refuerzo?: PlanRefuerzoPayload[];
}

@Injectable({ providedIn: "root" })
export class EvaluacionComportamientoSvService {
  private readonly baseUrl = `${environment.apiUrl}/api/evaluacion_comportamiento_sv`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get(this.baseUrl);
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  create(payload: EvaluacionComportamientoPayload): Observable<any> {
    return this.http.post(this.baseUrl, payload);
  }

  update(id: number, payload: Partial<EvaluacionComportamientoPayload>): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, payload);
  }

  activar(id: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/activar`, {});
  }

  inactivar(id: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/inactivar`, {});
  }

  getResumenColaborador(cedula: string, periodo: number): Observable<any> {
  return this.http.get(`${this.baseUrl}/resumen/${cedula}/${periodo}`);
}
}